const variants = {
  primary: 'bg-[var(--brand)] text-white hover:bg-[var(--brand-strong)] border-transparent',
  secondary:
    'bg-[var(--surface-panel)] text-[var(--text-primary)] border-[var(--border-subtle)] hover:bg-[var(--surface-panel-muted)]',
  ghost: 'bg-transparent text-[var(--text-secondary)] border-transparent hover:bg-[var(--surface-panel-muted)]',
  danger: 'bg-[var(--danger)] text-white border-transparent hover:opacity-90',
  warning: 'bg-[var(--warning)] text-white border-transparent hover:opacity-90',
};

export const Button = ({
  children,
  variant = 'secondary',
  className = '',
  loading = false,
  disabled = false,
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    disabled={disabled || loading}
    className={`inline-flex min-h-10 items-center justify-center gap-2 rounded-[var(--radius-md)] border px-4 py-2 text-sm font-semibold shadow-sm disabled:cursor-not-allowed disabled:opacity-60 ${variants[variant]} ${className}`}
    {...props}
  >
    {loading && <span className='h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent' />}
    {children}
  </button>
);
